export default __webpack_public_path__ + "static/media/expediente_azul.58864e1b.png";